import * as React from "react";

import { detectIE } from "../../../../../Engine/utils";

export interface CrossfitTableColumnGroupColumnProps {
    width: string | number;
    collapsed?: boolean;
}

export function CrossfitTableColumnGroupColumn(props: CrossfitTableColumnGroupColumnProps): JSX.Element {
    return <col style={{ width: props.collapsed ? (detectIE() ? "auto" : "initial") : props.width }} />;
}
